export default __webpack_public_path__ + "static/reviewmode-497206660b19d1a3f88461f36eebb633.png";